import { mutatorAction } from "satcheljs";
import { getAnchorStore } from "../store/anchorStore";
import getTabIdFromWindow from "../utils/getTabIdFromWindow";
import getAnchorMapKey from "../utils/getAnchorMapKey";

/**
 * Clears only the drawer anchor registration for one pane id in one window.
 * Use this instead of passing `null` to drawerPaneAnchorChangedMutator when callers
 * want explicit cleanup semantics.
 */
const clearDrawerPaneAnchorMutator: (targetWindow: Window, drawerPaneId: string) => void = mutatorAction("clearDrawerPaneAnchor", (targetWindow: Window, drawerPaneId: string): void => {
    const tabId = getTabIdFromWindow(targetWindow);
    const anchorKey = getAnchorMapKey(tabId, drawerPaneId);
    getAnchorStore().anchorMap.delete(anchorKey);
});

export default clearDrawerPaneAnchorMutator;
